import { LoaderCircle } from 'lucide-react'
import { FC, PropsWithChildren, useContext } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthenticationStatus } from '../hooks/useAuthenticationStatus'
import { useAuthenticatedUser } from '../hooks/useAuthenticatedUser'
import { AuthContext } from './provider'

export const AuthGate: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const location = useLocation();
  const { isLoading, isAuthenticated } = useAuthenticationStatus();
  const { user } = useAuthenticatedUser();
  const auth = useContext(AuthContext);

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-4">
        <LoaderCircle className="w-10 h-10 animate-spin text-slate-500" />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />
  }

  if (!user?.defaultRole || (!user.roles.includes('admin') && !user.roles.includes('SEO_ADMIN'))) {
    return <div className="flex flex-col items-center justify-center h-screen gap-4">
        <span className="max-w-md text-center">
            You are not authorized to access this application
        </span>
        <button onClick={() => auth.signOut()}>Sign out</button>
    </div>
  }

  return <>{children}</>
}